import { Container, SvgIcon } from '@mui/material';
import { NavigationItemOption, navItems } from '../config';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import { useUser } from '../../hooks/user';

export default function DashboardPage() {
  const user = useUser();
  return (
    <Container sx={{ pt: 8, display: 'flex', flexWrap: 'wrap', gap: 2 }}>
      {navItems
        .filter(
          (item) =>
            item.path !== '/dashboard' &&
            item.roles &&
            user?.role &&
            item.roles.includes(user.role),
        )
        .map((item) => (
          <ItemLink key={item.path} to={{ pathname: item.path }} {...item}>
            <SvgIcon fontSize="large">
              <path d={item.icon} />
            </SvgIcon>
            {item.title}
          </ItemLink>
        ))}
    </Container>
  );
}

const ItemLink = styled(Link)<NavigationItemOption>`
  color: ${({ theme }) => theme.palette.common.white};
  padding: ${({ theme }) => theme.spacing(2)};
  border-radius: ${({ theme }) => theme.spacing(1)};
  display: flex;
  background-color: ${({ color }) => color || 'black'};
  flex-direction: column;
  align-items: center;
  width: 128px;
  text-align: center;
  gap: ${({ theme }) => theme.spacing(1)};
  text-decoration: none;
  font-size: 16px;
`;
